(() => {
  'use strict';

  // Inject styles once
  const style = document.createElement('style');
  style.textContent = `
    #js-sticky-atc {
      display: none;
      position: fixed;
      bottom: 0; left: 0; right: 0;
      padding: 12px 16px;
      padding-bottom: max(12px, env(safe-area-inset-bottom));
      background: #fff;
      border-top: 1px solid #e5e7eb;
      z-index: 100;
      box-shadow: 0 -2px 8px rgba(0,0,0,0.06);
    }
    #js-sticky-atc.is-visible { display: block; }
    @media (min-width: 768px) { #js-sticky-atc { display: none !important; } }
    #js-sticky-atc-btn {
      width: 100%; height: 48px;
      border-radius: 6px;
      background-color: #3f9cd2;
      color: #fff;
      font-weight: 500;
      font-size: 0.9375rem;
      border: none;
      cursor: pointer;
    }
    #js-sticky-atc-btn:disabled {
      background-color: #e5e7eb;
      color: #9ca3af;
      cursor: not-allowed;
    }
    #js-sticky-atc-btn:not(:disabled):hover { background-color: #0a1f44; }
  `;
  document.head.appendChild(style);

  const bar = document.createElement('div');
  bar.id = 'js-sticky-atc';
  const btn = document.createElement('button');
  btn.id = 'js-sticky-atc-btn';
  bar.appendChild(btn);
  document.body.appendChild(bar);

  // Check if element is truly rendered (not inside a display:none ancestor)
  function isRendered(el) {
    return el && el.offsetParent !== null && !el.classList.contains('hidden');
  }

  function getActiveCta() {
    // Use offsetParent so we skip buttons inside hidden tab panels
    const subAtc   = document.querySelector('.js-sub-add-to-cart');
    const spareAtc = document.querySelector('.js-spare-add-to-cart');
    if (isRendered(spareAtc)) return spareAtc;
    if (isRendered(subAtc))   return subAtc;

    const subCheck   = document.querySelector('.js-sub-check-avail');
    const spareCheck = document.querySelector('.js-spare-check-avail');
    if (isRendered(spareCheck)) return spareCheck;
    if (isRendered(subCheck))   return subCheck;

    return document.querySelector('.js-buybox__product-addToCartBtn');
  }

  function syncBtn(cta) {
    if (!cta) return;
    // Mirror text + total for both sub and spare Add to Cart buttons
    const textEl  = cta.querySelector('.js-sub-btn-text, .js-spare-btn-text');
    const totalEl = cta.querySelector('.js-sub-btn-total, .js-spare-btn-total');
    if (textEl) {
      btn.textContent = textEl.textContent.trim() + (totalEl?.textContent?.trim() ? ' ' + totalEl.textContent.trim() : '');
    } else {
      btn.textContent = cta.textContent.trim();
    }
    btn.disabled = cta.disabled || false;
  }

  let currentCta = null;
  let iObserver   = null;

  function watchCta(cta) {
    if (!cta) return;
    currentCta = cta;
    syncBtn(cta);
    btn.onclick = () => cta.click();

    if (iObserver) iObserver.disconnect();
    iObserver = new IntersectionObserver(([entry]) => {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    }, { threshold: 0 });
    iObserver.observe(cta);
  }

  document.addEventListener('DOMContentLoaded', () => {
    watchCta(getActiveCta());

    // Scope observer to buybox only — not entire body
    const buybox = document.querySelector('.js-buybox, .js-sub-buybox');
    if (!buybox) return;

    let syncTimer = null;
    new MutationObserver(() => {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(() => {
        const newCta = getActiveCta();
        if (newCta && newCta !== currentCta) {
          watchCta(newCta);
        } else if (currentCta) {
          syncBtn(currentCta);
        }
      }, 100);
    }).observe(buybox, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class', 'disabled'],
    });
  });
})();
